import { connect } from 'react-redux'
import { StartMain } from './StartMain'
import { StartMainMapState } from './StartMainMapState'
import { StartMainMapDispatch } from './StartMainMapDispatch'

export const StartMainConnected = connect(
  StartMainMapState,
  StartMainMapDispatch
)(StartMain)
